<template>
  <v-row 
    v-if="active"
    justify="center"
  >
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      style="overflow: hidden;"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
          fab
          style="position:fixed;left:15px;bottom:10px;"
        >
        <v-icon>mdi-message-outline</v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-toolbar
          dark
          color="primary"
        >
          <v-toolbar-title>{{$t('messages.title', locale)}}</v-toolbar-title>
          <v-btn
            icon
            dark
            @click="handleDisconnect"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
              icon
              dark
              @click="dialog = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <chat-form
          v-if="!session && identForm"
          :locale="locale"
          :identForm="identForm"
          :onClose="handleClose"
          :onSave="prepareSession"
        />
        <chat 
          v-else
          :session="session"
          :locale="locale"
          :onDisconnect="handleDisconnect"
        />
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import Chat from './Chat'
import ChatForm from './ChatForm'
import apiMessages from '@/services/apiMessages'
import apiDtouch from '@/services/apiDtouch'
export default {
  components: {
    Chat,
    ChatForm,
  },
  props: {
    workspaceID: {
      type: String,
      required: true,
    },
    locale: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    dialog: false,
    session: null,
    active: false,
    isMessage: false,
    authRequired: false,
    iedentForm: null,
  }),
  computed: {
    chatToken () {
      return apiMessages.getToken()
    },
  },
  mounted () {
    this.handleGetConfig()
    // si esta logeado
    //this.prepareSession()
  },
  methods: {
    handleCheckIsActive () {
      if (!this.isMessage) {
        this.active = false
        return
      }
      if (this.authRequired) {
        this.active = false
        return
      }
      this.active = true
      this.handleCheckSession()
    },
    handleCheckSession () {
      if (this.chatToken) {
        this.session = this.chatToken
      }
    },
    handleGetConfig () {
      apiDtouch.getItem (`v1/public/workspaces/${this.workspaceID}/messages`)
        .then(response => {
          this.isMessage = response && response.Active ? true : false
          this.authRequired = response && response.AuthRequired ? true : false
          this.identForm = response && response.IdentForm ? response.IdentForm.split(',') : null
          this.handleCheckIsActive()
        })
    },
    prepareSession (v) {
      apiMessages.prepareToken(v)
        .then(response => {
          if (response && response.data && response.data.token) {
            this.session = response.data.token
            apiMessages.setToken(this.session)
          }
        })
    },
    handleDisconnect () {
      localStorage.removeItem(`chatSession${this.workspaceID}`)
      this.dialog = false
    },
    handleClose () {
      this.dialog = false
    },
  },
}
</script>

